
import React, { useEffect, useState } from "react";
import { Button, Col, Modal, Row } from "react-bootstrap";
import { Button as AntdButton } from "antd";

const TituloModal = ({ show, handleClose, titulos, data }) => {
  const [titulo ,setTitulo] = useState("");

  useEffect(()=> {
    const result = titulos.find((e) => e.NRO_INMUEBLE === data.IMPONIBLE && e.RECURSO === data.RECURSO);

    setTitulo(result);
  }, []);

  console.log({ titulo });
  return (
    <Modal show={show} onHide={handleClose} backdrop="static" animation={false} centered>
      <Modal.Header>
        <div className="ml-3">
          <h5>Título Ejecutivo</h5>
        </div>
      </Modal.Header>
      <Modal.Body className=''>
        <Row>
          <Col>
            <Row>
              <Col>Deuda reclamda por:</Col>
              <Col></Col>
            </Row>
            <Row>
              <Col>Expediente:</Col>
              <Col></Col>
            </Row>
            <Row>
              <Col>Monto:</Col>
              <Col></Col>
            </Row>
          </Col>
          <Col>
            <Row>
              <Col>Liquido al:</Col>
              <Col></Col>
            </Row>
            <Row>
              <Col>Fecha de Emisión:</Col>
              <Col></Col>
            </Row>
          </Col>
        </Row>
        <div className="m-3">
          <AntdButton>Descargar Título Ejecutivo</AntdButton>
        </div>
      </Modal.Body>
      <Modal.Footer className='d-flex justify-content-center'>
        <Button onClick={handleClose}>Aceptar</Button>
      </Modal.Footer>
    </Modal>
  );
};

export default TituloModal;
